import { ImgID } from "../../image_loader/img_id.js";
import { StatisticsStorage } from "../../storage/statistics_storage.js";
import { Vfx2DManager } from "../../webgl_2d/vfx_2d_manager.js";
import { ColorScheme } from "../common_ui_elements/color_scheme.js";
import { CurrencyBar } from "../common_ui_elements/currency_bar.js";
import { TextStyleScheme } from "../common_ui_elements/text_style_scheme.js";
import { UIElement } from "../common_ui_elements/ui_element.js";
import { UIImage } from "../common_ui_elements/ui_image.js";
import { UITextElement } from "../common_ui_elements/ui_text_element.js";

export const COIN_TRANSITION_BADGE_FADE_MS = 200;

export function addActiveCoinTransitionBadge(
  parent: UIElement,
  ctx: CanvasRenderingContext2D,
  fade_ms: number = COIN_TRANSITION_BADGE_FADE_MS
): void
{
  const coin_fly_finish_at = Vfx2DManager.getLatestCoinFlyFinishTime();
  if ( coin_fly_finish_at <= performance.now() )
    return;

  // Laid out exactly like the menu's coin block, which it stands in for.
  const bg_w = LayoutScaler.widthFromDesign( CurrencyBar.BLOCK_W );
  const bg_h = LayoutScaler.heightFromDesign( CurrencyBar.BLOCK_H );
  const bg_x = CurrencyBar.defaultCoinBlockX();
  const bg_y = LayoutScaler.yFromDesign( CurrencyBar.BLOCK_Y );
  const bg = new UIImage(
    ctx,
    bg_x,
    bg_y,
    bg_w,
    bg_h,
    ImgID.UI_MenuBlockBg
  );
  bg.setClickable( false );

  const count_w = LayoutScaler.widthFromDesign( CurrencyBar.COUNT_W );
  const count_right_pad = LayoutScaler.widthFromDesign( CurrencyBar.COUNT_RIGHT_PAD );

  const count_x = bg_w - count_w - count_right_pad;
  const count = new UITextElement(
    ctx,
    count_x,
    0,
    count_w,
    bg_h,
    {
      text: StatisticsStorage.load().coins.toString(),
      font_size: LayoutScaler.textSizeFromDesign( CurrencyBar.COUNT_FONT ),
      font_weight: 700,
      text_color: ColorScheme.menu_top_el_text,
      text_style: TextStyleScheme.rubik,
    }
  );
  count.setClickable( false );
  bg.addChild( count );
  bg.fadeOut( fade_ms, coin_fly_finish_at );
  parent.addChild( bg );
}
